"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _datadog = require("../utils/datadog");
var _getDownstreamNameFromAction = require("../utils/getDownstreamNameFromAction");
var _Integrations = require("../constants/Integrations");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 *
 * @param supportedIntegrations
 * @param actionName
 * @param data
 */
var datadogLogger = function datadogLogger(supportedIntegrations, actionName, data) {
  try {
    if (supportedIntegrations.includes(_Integrations.DATADOG)) {
      var datadogInstance = (0, _datadog.getDatadogRumInstance)();
      var downstreamName = (data === null || data === void 0 ? void 0 : data.downstreamName) || (0, _getDownstreamNameFromAction.getDownstreamNameFromAction)(actionName);
      if (datadogInstance === undefined) {
        console.warn("DataDog RUM was never initialized. Therefore ".concat(downstreamName, " action was not sent >>>>"), data);
        return;
      }
      (0, _datadog.getDatadogRumInstance)().addAction("studio ".concat(downstreamName), _objectSpread(_objectSpread({}, data), {}, {
        downstreamName: downstreamName
      }));
    }
  } catch (e) {
    console.warn('Failed to send to datadog RUM >>>>', e);
  }
};
var _default = exports["default"] = datadogLogger;